export default "__VITE_ASSET__Dd5GqGpv__"